// import { Box, Button, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
// import theme as homeTheme from './theme'

export const TitleImage = styled('img')(({ src }) => ({
    src: `url(${src})`,
    // backgroundImage: `url(${src})`,
    backgroundRepeat: 'no-repeat',
    // backgroundPosition: 'center',

    // [theme.breakpoints.down('md')]: {
    //     width: '180px',
    //     height: '72px',
    // },

    // [theme.breakpoints.down('sm')]: {
    //     width: '120px',
    //     height: '48px',
    // },
}))
